import React, { useState } from "react";
import axios from "axios";
import { Link,useNavigate } from "react-router-dom";

const Dashboard = () => {
    const tutor = JSON.parse(localStorage.getItem("tutor"));
    
    return (
     <>
      <div className="container-fluid mt-5">
         <h1>Welcome, {tutor?.first_name}!</h1>
         <Link to="/logout">Logout</Link>
       </div>
     </>);
}
export default Dashboard;